import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const TitleContent = props => (
  <h5 className={`TitleContent color--${props.color}`}>{props.text}</h5>
);

TitleContent.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default TitleContent;
